import { StateService } from "@uirouter/angularjs";
import { $confirm } from "../../../../../../../@custom_types/confirm";
import { Record } from "../../../../../../records/server/crud";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../../../../records/server/serverUtility";
import {
  ChangeJournalModalService,
  vsServiceName as ChangeJournalModalServiceName,
} from "../../../../../../records/changeJournal/changeNoteModalService";

export class MachineConfigurationTypeInfoComponentController {
  public readonly machineConfigurationType!: Record;

  static $inject = [
    "$confirm",
    ServerUtilityName,
    "$state",
    ChangeJournalModalServiceName,
  ];
  constructor(
    private readonly $confirm: $confirm,
    private readonly serverUtility: ServerUtility,
    private readonly $state: StateService,
    private readonly changeJournalModalService: ChangeJournalModalService
  ) {}

  delete() {
    this.$confirm({
      text: "Are you sure you want to delete this Configuration Type?  Any machines with this Configuration Type will no longer be associated with any Machine Configuration Type after deletion.",
    })
      .then(() => this.changeJournalModalService.getChangeJournalNote())
      .then((note) =>
        this.serverUtility
          .delete({
            url: "/api/machines/MachineConfigurationType",
            id: this.machineConfigurationType.Id,
            params: {"Note": note.Note},
          })
          .then(() => {
            this.$state.go("^.^");
          })
      );
  }
}
